module.exports = __webpack_public_path__ + "img/services-banner.10459dad.png";